<template>
    <div class="header" :class="[isActive && `show`, isActiveMobileMenu && `is-mobile-menu`]">

        <button v-if="!isMenuDesktop" type="button" class="mobile-menu-button" :class="isActiveMobileMenu && `active`"
            @click.prevent="activeMobileMenuHandle" :title="$t('menu')">
            <span class="material-symbols-outlined">menu</span>
        </button>

        <a href="/" class="header-logo">
            <LogoBrand v-if="width < 320" width="48" height="48" />
            <LogoEN v-else-if="locale == 'en'" :height="width <= 360 ? 42 : 48" />
            <Logo v-else height="48" />
        </a>

        <div class="header-container" v-if="!isActiveMobileMenu">
            <div class="header-nav">
                <desktop-menu class="header-nav-item" :menus="menus" v-if="isMenuDesktop"></desktop-menu>
            </div>

            <div class="header-right">
                <div class="header-nav-red" v-if="(menuRed.length > 0 && isMenuRed)">
                    <div class="header-nav">
                        <div class="header-nav-item" v-for="(item, index) in menuRed" :key="index">
                            <a class="header-nav-link" :href="item.url" target="_blank">
                                <span class="header-nav-text">{{ item.name }}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="header-nav" v-if="isMenuRight">
                    <div class="header-nav-item" v-if="!isAuthCheck">
                        <a class="header-nav-link" href="/login">
                            <span class="material-symbols-outlined">login</span>
                            <span class="header-nav-text">{{ $t('Login') }}</span>
                        </a>
                    </div>

                    <div class="header-nav-item dropdown" v-else>
                        <button type="button" class="header-nav-link" @click="isDropdownUser = !isDropdownUser">
                            <span class="material-symbols-outlined">account_circle</span>
                            <span class="header-nav-text">{{ $t('Profile') }}</span>
                        </button>

                        <div class="header-dropdown-menu dropdown-user" v-if="isDropdownUser">
                            <div class="dropdown-body">
                                <a class="dropdown-link" href="/account">{{ $t('Profile') }}</a>
                                <a class="dropdown-link" href="/account/project">{{ $t('Project') }}</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-link" href="/logout">{{ $t('Logout') }}</a>
                            </div>
                        </div>
                    </div>

                    <div class="header-nav-divider"></div>
                    <div class="header-nav-languages">
                        <template v-for="(item, index) in languageList">
                            <span :key="index" class="lang-divider" v-if="item.divider">/</span>
                            <a v-else class="lang-link" :class="(locale == item.lang && `active`)"
                                :href="`/lang/${item.lang}`" :key="item.lang">
                                <span class="lang-text">{{ item.lang }}</span>
                            </a>
                        </template>

                    </div>
                </div>
                <div class="header-nav">
                    <div class="header-nav-item">
                        <button tabindex="-1" type="button" class="header-nav-link" @click="searchHandle">
                            <span class="material-symbols-outlined">search</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <mobile-menu v-else :isActiveMobileMenu="isActiveMobileMenu" :menus="menus" :menuRed="menuRed" :isAuth="isAuth"
            :languages="languages" :locale="locale"></mobile-menu>
    </div>
</template>

<script>
import DesktopMenu from './DesktopMenu.vue'
import MobileMenu from './MobileMenu.vue'
import Logo from '../components/Logo.vue'
import LogoEN from '../components/LogoEN.vue'
import LogoBrand from '../svg/LogoBrand.vue'
export default {
    components: { Logo, LogoEN, MobileMenu, DesktopMenu, LogoBrand },
    props: ['locale', 'languages', 'menus', 'menuRed', 'isAuth', 'user'],

    data() {
        return {
            isActive: false,
            isMenuRed: false,
            isMenuRight: false,
            isMenuDesktop: false,

            languageList: [],

            width: null,

            isActiveMobileMenu: false,
            isDropdownUser: false,
        }
    },

    computed: {
        activeDesktopMenu() {
            return this.$store.getters.activeDesktopMenu
        },

        isAuthCheck() {
            return parseInt(this.isAuth) ? true : false
        }
    },

    watch: {
        isActiveMobileMenu(val) {
            if (val) {
                document.body.classList.add('has-mobile-menu');
            }
            else {
                document.body.classList.remove('has-mobile-menu');
            }
        }
    },

    mounted() {
        this.$i18n.locale = this.locale
        this.onInit()

        let row = 0;
        for (const lang in this.languages) {
            row++;

            if (Object.hasOwnProperty.call(this.languages, lang)) {
                if (row > 1) {
                    this.languageList.push({ divider: true })
                }

                this.languageList.push({
                    lang: lang
                })
            }
        }

        setTimeout(() => {
            this.isActive = true
        }, 200);
    },

    destroyed() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.resizeHandler);
            window.removeEventListener("scroll", this.scrollHandler);
        }
    },

    methods: {
        activeDesktopMenuHandle() {
            this.$store.dispatch('setSegmentPersonnelModal', !this.activeDesktopMenu)
        },

        onInit() {
            if (typeof window !== "undefined") {
                this.resizeHandler();
                this.scrollHandler();

                window.addEventListener("resize", this.resizeHandler);
                window.addEventListener("scroll", this.scrollHandler);
            }
        },
        resizeHandler() {
            this.width = window.innerWidth


            this.isMenuRed = this.width >= 1780
            this.isMenuRight = this.width >= 900
            this.isMenuDesktop = this.width >= 900

            if (this.width >= 900) {
                this.isActiveMobileMenu = false
            }

            // this.$store.commit("ui/SET_WIDTH", window.innerWidth);
        },
        scrollHandler() {
            // this.$store.commit("ui/SET_SCROLLY", window.scrollY);
        },

        activeMobileMenuHandle() {
            this.isActiveMobileMenu = !this.isActiveMobileMenu
        },

        searchHandle() {
            this.$store.dispatch('hasSearch', true)
        }
    }
}
</script>

<style lang="scss" scoped>
#top-main-header .ku-logo {
    flex-shrink: 0;
    width: 76px
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    // position: relative;
    // opacity: 0;
    user-select: none;
    // transform: translateY(-100%);
    transition: height 100ms cubic-bezier(0.15, 0.15, 0, 1) 0s, opacity 250ms cubic-bezier(0.15, 0.15, 0, 1) 0s, transform 250ms cubic-bezier(0.15, 0.15, 0.15, 1) 0s;

    &.show {
        // opacity: 1;
        // user-select: all;
        transform: translateY(0);

        .header-logo {
            opacity: 1;
        }

        .header-container {
            opacity: 1;
        }
    }


}

.header-logo {
    opacity: 0;

    position: absolute;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 920ms cubic-bezier(0.15, 0.15, 0, 1) 0s;

    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;
    padding-left: 15px;
    padding-right: 15px;

    &:hover {
        .logo-lightning {
            // animation-play-state: paused;
            animation-duration: .6s;
            // animation-delay: 1200ms;
            animation-timing-function: ease-in-out;
            // animation-iteration-count: infinite;
            animation-iteration-count: 1;
            animation-name: logo-lightning;
            animation-fill-mode: forwards;
            animation-play-state: running;
        }
    }

    .logo-lightning {
        opacity: 0;
        width: 10rem;
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        background: linear-gradient(45deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, .3) 100%, rgba(255, 255, 255, 0) 0);
        // background: linear-gradient(45deg, rgba(255, 255, 255, 0) 0, rgba(113, 45, 125, .7) 100%, rgba(255, 255, 255, 0) 0);
        transform: skew(45deg);
        pointer-events: none;
        // transition: all .25s ease;
        // 


    }
}

@keyframes logo-lightning {
    0% {
        opacity: 0;
        transform: skew(45deg) translateX(-100%)
    }

    50% {
        opacity: 1;
        transform: skew(45deg) translateX(10%)
    }

    100% {
        opacity: 0;
        transform: skew(45deg) translateX(100%)
    }
}

.header-container {
    position: relative;
    opacity: 0;
    transition: opacity 520ms cubic-bezier(0.15, 0.15, 0, 1) 0s;

    display: flex;
    justify-content: space-between;
    height: 100%;

    padding-left: 0;
    padding-right: 0;
    width: 100%;

    max-width: 1800px;
    margin-left: auto;
    margin-right: auto;
}

.header-nav {
    display: flex;
    gap: 5px;
    align-items: center;
    height: 100%;
}

.header-nav-divider {
    height: 80%;
    max-height: 25px;
    width: 1px;
    background-color: rgba(255, 255, 255, .6)
}

.header-nav-item {
    position: relative;
    display: flex;
    height: 100%;
}

.header-nav-link {
    position: relative;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    color: var(--header-color, #fff);
    text-decoration: none;
    height: 100%;

    padding-left: 15px;
    padding-right: 15px;
    gap: 6px;

    &:hover {
        color: var(--header-hover-color, #fff);
        text-decoration: none;

        background-color: rgba(0, 0, 0, .1);
    }
}

.header-nav-icon {
    font-size: 38px;
}

.header-nav-languages {
    display: flex;
    gap: 5px;
    align-items: center;
    height: 100%;
    padding-left: 15px;
    padding-right: 15px;

    .lang-text {
        text-transform: uppercase;
    }

    .lang-divider{
        line-height: 1;
        opacity: .6;
        color: var(--header-color, #fff);
    }

    .lang-link {
        position: relative;
        display: flex;
        align-items: center;
        color: var(--header-color, #fff);
        text-decoration: none;
        opacity: .6;

        &.active {
            font-weight: bold;
            opacity: 1;
            color: var(--header-color, #fff);
        }

        &:hover {
            color: var(--header-hover-color, #fff);
            text-decoration: none;
            opacity: 1;
        }

        

        &:first-child {
            &::before {
                display: none
            }
        }
    }
}

.header-right {
    display: flex;
}

.header-nav-red {
    background-color: #c32237;
    

    border-radius: 0 0 15px 15px;
    margin-bottom: 15px;
    margin-right: 8px;

    display: flex;
    overflow: hidden;

    .header-nav-link {
        padding-left: 8px;
        padding-right: 8px;
    }
}
.mobile-menu-button {
    position: fixed;
    top: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;

    border: none;
    color: var(--header-color, #fff);

    text-decoration: none;
    height: 72px;
    width: 50px;

    z-index: 10;
}

@media only screen and (max-width: 833px) {
    .header {
        overflow-y: hidden;
        max-height: none;
        backdrop-filter: none;
        transition: background-color .44s .2s cubic-bezier(0.52, 0.16, 0.24, 1), height .56s cubic-bezier(0.52, 0.16, 0.24, 1);

        &.is-mobile-menu {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;

            height: 100%;

            display: flex;
            flex-direction: column;

            .header-logo {
                position: sticky;
                top: 0;
                width: 100%;
                left: 0;
                transform: translateX(0);
                height: 72px;
            }
        }
    }
}


.dropdown {
    position: relative;
}

.header-dropdown-menu {
    position: absolute;
    top: 100%;

    background-color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;

    &.dropdown-user {
        width: 250px;
        right: 0;
    }

    .dropdown-body {
        display: flex;
        flex-direction: column;
    }

    .dropdown-link {
        display: flex;
        gap: 4px;
        align-items: center;
        font-size: 18px;
        text-decoration: none;

        padding: 8px 24px;
        color: #101010;

        &:hover {
            background-color: #f2f2f2;
        }
    }

    .dropdown-divider {
        height: 1px;
        background-color: #eee;
    }
}
</style>